/** Transient confirmation of an action the user just took. Never used for errors that need a decision. */

import { useEffect } from 'react';
import { useStore } from '../state/store.ts';

const DWELL_MS = 3200;

export function Toast() {
  const toast = useStore((state) => state.toast);
  const clearToast = useStore((state) => state.clearToast);

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(clearToast, DWELL_MS);
    return () => window.clearTimeout(timer);
  }, [toast, clearToast]);

  if (!toast) return null;

  return (
    <div
      className={`toast${toast.tone === 'error' ? ' error' : ''}`}
      role={toast.tone === 'error' ? 'alert' : 'status'}
      aria-live={toast.tone === 'error' ? 'assertive' : 'polite'}
    >
      {toast.message}
    </div>
  );
}
